import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  AVAILABLE_CUSTOM_ROLE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import OsHome from './OsHome.vue';

// The PowerbizzOS launcher: every logged-in user lands here, whatever their
// role, so the permission list is the full set the router knows about.
const EVERYONE = [
  ...ROLES,
  'custom_role',
  ...AVAILABLE_CUSTOM_ROLE_PERMISSIONS,
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/home'),
      name: 'os_home',
      meta: {
        permissions: EVERYONE,
        // ACESSO-01 (L8b): de todo membro da conta, com a chave ACESSO_GRANULAR ligada ou não.
        escopos: [],
      },
      component: OsHome,
    },
  ],
};
